export default __webpack_public_path__ + "static/media/noDataFound.fde7d5a6.svg";